import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { NgbModal, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { ListFilter } from 'src/app/core/list-filter.model';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxTransmissionMethod } from 'src/app/core/PDxTransmissionMethod.enum';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { VendorSummary } from '../models/vendor-summary.model';
import { NgForm } from '@angular/forms';
import { TableSorting } from 'src/app/core/tableSorting.component';
import { Router } from '@angular/router';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styles: [
  ]
})
export class VendorListComponent implements OnInit {

  @ViewChild('exportForm') exportForm: ElementRef;

  showList: boolean = false;
  accounts: PDxListItem<string>[] = [];
  pdxTransmissionMethod = PDxTransmissionMethod;
  filterCount: number = 0;
  selectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
              this.filter.accountId = null;
            }
          }
        }, () => { });
      } else {
        if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
          this.filter.accountId = null;
        }
      }
      return false;
    },
    onChange: (event, inst) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.filter.accountId = null;
      }
    }]
  };
  filter: VendorListFilter;
  results: DataTablesResponse<VendorSummary>;

  constructor(private ajax: ajaxCall,
    private modalService: NgbModal,
    private notifier: NotifierService,
    private dirtyService: DirtyTrackingService,
    private router: Router,
    private confirm: ConfirmService) { }

  ngOnInit(): void {
    this.accounts = [];
    this.poTransmissionTypes.unshift({ value: null, text: 'Any' });
    this.resetFilters();
  }

  resetFilters(): void {
    this.filter = new VendorListFilter(8, 'Name', 'asc');
    this.filter.vendorStatus = this.statusFilters.filter(x => x.value === true)[0];
    this.filter.poTransmissionType = this.poTransmissionTypes[0];
    this.hideTheList();
  }

  showTheList(): void {
    if (!this.showList) {
      this.loadList(true);
    }
  }

  hideTheList(): void {
    this.showList = false;
  }

  loadList = (reset: boolean = false) => {
    if (reset) {
      this.filter.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<VendorSummary>>('/Vendor/FullList', this.filter).then(results => {
      this.results = results;
      this.showList = true;
    }, () => { console.log('error'); });
  }

  inputFieldChange(ev: KeyboardEvent): void {
    if (ev.key == 'Enter') {
      this.showTheList();
    }
  }

  viewVendor(vendorId: string): void {
    if (vendorId) {
      this.router.navigate(['/manage/vendor', vendorId]);
    } else {
      this.router.navigate(['/manage/vendor']);
    }
  }

  statusFilters: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Active' },
    { value: false, text: 'Deactivated' }
  ];
  selectStatusFilter(f: PDxListItem<boolean>): void {
    this.filter.vendorStatus = f;
    this.hideTheList();
  }

  poTransmissionTypes: PDxListItem<PDxTransmissionMethod>[] = PDxLists.PDxTransmissionMethods();
  selectTransmissionType(f: PDxListItem<PDxTransmissionMethod>): void {
    this.filter.poTransmissionType = f;
    this.hideTheList();
  }

  exportVendors(): void {
    this.exportForm.nativeElement.submit();
  }
}

class VendorListFilter extends ListFilter {
  nameFilter?: string;
  accountId?: string;
  vendorStatus?: PDxListItem<boolean>;
  poTransmissionType?: PDxListItem<PDxTransmissionMethod>;
}